export const UPDATE_PSEUDONYM_FAILURE = 'UPDATE_PSEUDONYM_FAILURE';

export const updatePseudonymFailure = error => ({
    type: UPDATE_PSEUDONYM_FAILURE,
    payload: error,
    error: true,
});
